import React, { useState } from "react";
import "./SignUp.css";
import { FaUser, FaEnvelope, FaLock } from "react-icons/fa";

const SignUp = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    setUserData({
      ...userData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(userData);
  };

  return (
    <div className="container">
      <div className="signup-container">
        <div className="signup-image">
          <img
            src="https://images.unsplash.com/photo-1672161689485-56c2bee73f0d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
            alt="background"
          />
        </div>
        <div className="signup-form">
          <form onSubmit={handleSubmit}>
            <h1>Create an account</h1>
            <div className="input-container">
              <FaUser className="input-icon" />
              <input
                type="text"
                placeholder="Full Name"
                name="name"
                value={userData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                placeholder="Email Address"
                name="email"
                value={userData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <FaLock className="input-icon" />
              <input
                type="password"
                placeholder="Password"
                name="password"
                value={userData.password}
                onChange={handleChange}
                minLength="6"
                required
              />
            </div>
            <button type="submit">Sign Up</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
